@if (corpus) {
<div class="p-stack--row p-h-full p-max-h-full p-overflow-hidden">
  <app-transformer-toolbar
    [corpus]="corpus"
    [enabled]="editable"
    (formatRequested)="createTrainingData()"
    (back)="back.emit()"
  ></app-transformer-toolbar>

  <div class="p-divider"></div>

  <app-data-grid
    [dataService]="gridDataService"
    [rendererProvider]="gridRendererService"
    [editable]="editable"
    [externalTransforming]="isTransforming"
    (columnEdit)="columnsChanged($event)"
    (columnTypeEdit)="columnTypeChanged($event)"
  ></app-data-grid>

  <div class="p-divider"></div>

  <app-transform-history [corpus]="corpus" [editable]="editable"></app-transform-history>
</div>
}
